// extracted by mini-css-extract-plugin
module.exports = {"emptyBox":"styles_emptyBox__lEPNn","emptyImage":"styles_emptyImage__rbAMB","emptyTitle":"styles_emptyTitle__IwVKY","emptyDescription":"styles_emptyDescription__kRf2r"};